import { createContext, ReactNode, useEffect, useState } from 'react';
import { LocalizationConfig, mapLocalizationResponse } from '../../api/localizationResponse.mapper';
import { getWidgetCMSData } from '../../api/widgetCmsData';
import { PlatformCMSUrl, WIDGET_LOCALIZATION_CONTENT_SLUG } from '../../common';
import { getBrowserLang } from '../../utils';

interface LocalizationContextModel {
  localization: LocalizationConfig;
  setLocalization: React.Dispatch<React.SetStateAction<LocalizationConfig>>;
}

export const LocalizationContext = createContext<LocalizationContextModel | undefined>(undefined);

export const LocalizationProvider = ({ children }: { children: ReactNode }) => {
  const [localization, setLocalization] = useState<LocalizationConfig>({} as LocalizationConfig);

  useEffect(() => {
    const loadData = async () => {
      const data = await getWidgetCMSData(
        PlatformCMSUrl(),
        WIDGET_LOCALIZATION_CONTENT_SLUG,
        getBrowserLang(),
      );

      setLocalization(mapLocalizationResponse(data!));
    };

    loadData();
  }, []);

  return (
    <LocalizationContext.Provider value={{ localization, setLocalization }}>
      {children}
    </LocalizationContext.Provider>
  );
};
